import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { Box, Button, CircularProgress, Container, Typography, useTheme, } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Download, NotePencil } from "@phosphor-icons/react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import WorkPreparationContracts from "../../../infrastructure/api/pages/work-preparation-contracts-api";
import { sanitizeFileName } from "../../../application/common/utils/file-name-helper";
export const WorkPreparationBreadCrumb = ({ orderNumber, companyName, leadNumber, setCompleted, loader, copied, dataLoading, }) => {
    const { t: translate } = useTranslation();
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    const urlParams = new URLSearchParams(window.location.search);
    const contractId = urlParams.get("id");
    const handleClose = () => {
        setOpen(false);
    };
    const handleOpen = () => {
        setOpen(true);
    };
    const completeContract = () => {
        setCompleted(true);
    };
    const downloadDocument = () => {
        if (contractId) {
            WorkPreparationContracts.downloadExcelDocument(contractId)
                .then((response) => {
                if (response.status === 200 && response.data != null) {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    const sanitizedCompanyName = sanitizeFileName(companyName);
                    const fileName = sanitizedCompanyName
                        ? `Inschrijfformulier - ${sanitizedCompanyName} - ${leadNumber !== null && leadNumber !== void 0 ? leadNumber : ""}.xlsx`
                        : 'Inschrijfformulier.xlsx';
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                }
            })
                .catch((error) => {
                console.error("Er is een fout opgetreden bij het downloaden van het document!", error);
            });
        }
    };
    return (_jsx(Container, { disableGutters: true, sx: { maxWidth: "100% !important" }, children: _jsxs(Box, { sx: {
                display: "flex",
                spacing: 1,
                justifyContent: "space-between",
                flexDirection: { xs: "column", sm: "row", md: "row" },
            }, children: [_jsxs(Box, { children: [_jsx(Typography, { variant: "h1", sx: { color: theme.palette.text.primary }, children: translate("WorkPreparation") }), _jsx(Box, { sx: {
                                display: "flex"
                            }, children: _jsxs(Breadcrumbs, { "aria-label": "breadcrumb", children: [_jsxs(Link, { underline: "hover", color: "inherit", href: "/workpreparation", children: [_jsx(NotePencil, {}), translate("ContractList")] }), _jsxs(Link, { underline: "hover", color: "inherit", children: [translate("ContractNumber"), " #", orderNumber] })] }) })] }), _jsxs(Box, { sx: { display: "flex", justifyContent: "flex-end" }, children: [_jsx(Button, { variant: "contained", size: "medium", sx: { marginRight: "5px" }, startIcon: _jsx(Download, { size: 16 }), onClick: downloadDocument, disabled: dataLoading, children: translate("Download document") }), _jsx(Button, { variant: "contained", size: "medium", sx: { marginRight: "5px" }, onClick: handleOpen, disabled: copied, children: translate("Complete") })] }), _jsxs(Dialog, { open: open, onClose: handleClose, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", children: [_jsx(DialogContent, { children: _jsx(DialogContentText, { id: "alert-dialog-description", children: translate("Are you sure you have copied the details?") }) }), _jsxs(DialogActions, { children: [_jsx(Button, { onClick: handleClose, variant: "outlined", color: "error", size: "small", children: "Nee" }), _jsxs(Button, { onClick: completeContract, variant: "contained", color: "success", size: "small", autoFocus: true, children: [loader ? _jsx(CircularProgress, { size: 20, color: "inherit" }) : _jsx(_Fragment, {}), "Ja"] })] })] })] }) }));
};
